module.exports = __webpack_public_path__ + "static/logo-slim-2159e5d27cd827b55bfacaa1ce7baf12.svg";